import { MENULER, TARIFLER } from "../menuData.js";
import { EN_MENULER, EN_TARIFLER } from "../englishMenuData.js";
import {
  buildCookingDataset,
  getRecipeFromCookingData,
  validateCookingDataset,
} from "./schema.js";

export const TR_COOKING_DATA = buildCookingDataset({
  locale: "tr",
  menus: MENULER,
  recipes: TARIFLER,
});

export const EN_COOKING_DATA = buildCookingDataset({
  locale: "en",
  menus: EN_MENULER,
  recipes: EN_TARIFLER,
});

export function getCookingDataByLanguage(lang = "tr") {
  return lang === "en" ? EN_COOKING_DATA : TR_COOKING_DATA;
}

export function validateAllCookingData(options = {}) {
  return {
    tr: validateCookingDataset(TR_COOKING_DATA, options),
    en: validateCookingDataset(EN_COOKING_DATA, options),
  };
}

export { getRecipeFromCookingData, validateCookingDataset };
